import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import voicesReducer from './slices/voicesSlice';
import ttsReducer from './slices/ttsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    voices: voicesReducer,
    tts: ttsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/setUser'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.createdAt', 'payload.lastLoginAt'],
        // Ignore these paths in the state
        ignoredPaths: ['auth.user.createdAt', 'auth.user.lastLoginAt'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;